import { Link } from 'react-router-dom';
import style from './style.module.scss';

export default function LegalLinks() {
    return <nav className={style.legalLinks}>
        <Link to={'/polityka-prywatnosci'}>Polityka Prywatności</Link>
    </nav>
}
